import styled from 'styled-components';
import { Row, Col } from 'antd';

export const RowFilters = styled(Row)`
    display: flex;
    transition: all ease 0.4s;
`;

export const ColTitle = styled(Col)`
    display: flex;
    flex-wrap: wrap;
`;

export const Card = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: #FFFFFF;

    padding: 16px;
    border: 1px solid #dce0e8;
    border-radius: 12px;
    text-align: left;
    margin-top: 30px;

    strong {
        font-size: 18px;
        font-weight: 600;
        color: #1d1d1b;
        opacity: 0.9;

        margin-bottom: 10px;
    }

    p {
        font-size: 14px;
        color: #1d1d1b;
        font-weight: 500;
        opacity: 0.9;

        & + p {
            margin-bottom: 15px;
        }
    }
`;
